import {
  IsNotEmpty,
  IsBoolean,
  IsNumber,
  IsOptional,
  IsIn,
  ValidateIf,
} from "class-validator";

import { Constants } from "@eagerdog/constants";
import { IRatRaceScore, RAT_RACE_TIME_OPTIONAL_RESULTS } from "./rat-race-score.interface";

export class RatRaceScoreDto implements IRatRaceScore {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @ValidateIf(
    (score: RatRaceScoreDto) =>
      !RAT_RACE_TIME_OPTIONAL_RESULTS.includes(score.result_type) ||
      (score.time !== undefined && score.time !== null)
  )
  @IsNotEmpty()
  @IsNumber()
  time?: number; //seconds

  @IsNotEmpty()
  @IsNumber()
  fault_count: number;

  // only for "Fantastic Five"
  @IsOptional()
  @IsNumber()
  rats_found?: number;
  // false_alerts => use faults
}
